var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#25477c;}.cls-4{fill:#c7483d;}.cls-5{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 20,
    cy: 20,
    r: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M-19.78,27.22q0-7,0-14c0-.39.15-.5.5-.46h.47q38.84,0,77.66,0c.76,0,1,.13,1,1-.06,4.5,0,9-.05,13.49a1.1,1.1,0,0,1-.8.25c-.26,0-.52,0-.78,0H-18.2C-18.73,27.47-19.3,27.61-19.78,27.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M-19.78,27.22H59.76c0,3.56,0,7.12,0,10.68a3.23,3.23,0,0,1-3.2,3H-16c-1.94,0-3.2-.83-3.65-2.42a2.12,2.12,0,0,1-.11-.61Q-19.78,32.56-19.78,27.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M-19.77,12.78H59.77c0-3.56,0-7.12,0-10.68a3.24,3.24,0,0,0-3.2-3H-16c-1.94,0-3.19.83-3.64,2.42a2.12,2.12,0,0,0-.11.61Q-19.79,7.44-19.77,12.78Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRu);
export default __webpack_public_path__ + "static/media/ru.97178ae54109e0c42df282404bfa3973.svg";
export { ForwardRef as ReactComponent };